/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BASE_URL from "config/Base_URL";
import axios from "axios";

// @mui material components
import Card from "@mui/material/Card";
// import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/background.jpg";

function Cover() {
  const navigate = useNavigate();
  const [namaLengkap, setNamaLengkap] = useState("");
  const [namaUsaha, setNamaUsaha] = useState("");
  const [username, setUsername] = useState("");
  const [noTelepon, setNoTelepon] = useState("");
  const [alamat, setAlamat] = useState("");
  const token = sessionStorage.getItem("token");

  const handleSignUp = async (e) => {
    e.preventDefault();

    // Buat FormData object
    const formData = new FormData();
    formData.append("name", namaLengkap);
    formData.append("businessName", namaUsaha);
    formData.append("username", username);
    formData.append("noHp", noTelepon);
    formData.append("address", alamat);

    try {
      //   console.log(token);
      await axios.post(`${BASE_URL}/regis`, formData, {
        headers: {
          // Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire("Sukses!", "Registrasi berhasil", "success");
      navigate("/authentication/sign-in");

      setNamaLengkap("");
      setNamaUsaha("");
      setUsername("");
      setNoTelepon("");
      setAlamat("");
    } catch (error) {
      console.error("Registrasi gagal:", error.response?.data?.message || "Terjadi kesalahan");

      Swal.fire({
        icon: "error",
        title: "Registrasi Gagal",
        text: "User ini telah digunakan",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="success"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-8}
          p={2}
          mb={2}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Daftarkan Usaha
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Masukkan email dan password untuk daftar
          </MDTypography>
        </MDBox>
        <MDBox mt={4} pb={3} px={3} mb={4}>
          <MDBox component="form" role="form" onSubmit={handleSignUp}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Nama Lengkap"
                value={namaLengkap}
                onChange={(e) => setNamaLengkap(e.target.value.toUpperCase())}
                variant="standard"
                fullWidth
                required
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Nama Usaha"
                value={namaUsaha}
                onChange={(e) => setNamaUsaha(e.target.value.toUpperCase())}
                variant="standard"
                fullWidth
                required
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value.toUpperCase())}
                variant="standard"
                fullWidth
                required
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="No Telepon"
                value={noTelepon}
                onChange={(e) => {
                  const newValue = e.target.value.replace(/\D/g, "");
                  setNoTelepon(newValue);
                }}
                variant="standard"
                fullWidth
                required
                inputProps={{
                  maxLength: 13,
                  pattern: "[0-9]*",
                  inputMode: "numeric",
                }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Alamat"
                value={alamat}
                onChange={(e) => setAlamat(e.target.value.toUpperCase())}
                variant="standard"
                fullWidth
                required
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="success" fullWidth>
                sign up
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Already have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="success"
                  fontWeight="medium"
                  textGradient
                >
                  Sign In
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
